import { Select } from 'antd';

import { Location } from 'types/commons';
import { FormattedOption } from 'types/dictionaries';

import formatOptionParentKey from './formatOptionParentKey';

const { Option, OptGroup } = Select;

interface getOptionsGroupedByParentKeyProps {
  itemsList: any[];
  labelKey: string[];
  additionalLocationLabelKey?: string[];
  valueKey: string[];
  parentKey: string[];
  isFormatParentKey?: boolean;
  parentKeyMappingDict?: FormattedOption[];
}

type FormattedItem = FormattedOption & {
  additionalLocationLabel: Location | null;
};

const OTHER_GROUP_KEY = 'Other';

const formatLocation = (location: Location | null) => {
  if (!location) {
    return '';
  }

  const { city, state } = location;

  if (!city) {
    return '';
  }

  if (!state) {
    return city;
  }

  return `${city}, ${state}`;
};

export const getOptionsGroupedByParentKey = ({
  itemsList,
  labelKey,
  additionalLocationLabelKey,
  valueKey,
  parentKey,
  isFormatParentKey = true,
  parentKeyMappingDict
}: getOptionsGroupedByParentKeyProps) => {
  const parentKeyMap = parentKeyMappingDict
    ? new Map(parentKeyMappingDict.map((item) => [item.value, item.label]))
    : null;

  const formattedItems = itemsList
    .map((item) => ({
      label: labelKey.reduce((obj, prop) => obj && obj[prop], item),
      parentKey:
        parentKey.reduce((obj, prop) => obj && obj[prop], item) ||
        OTHER_GROUP_KEY,
      value: valueKey.reduce((obj, prop) => obj && obj[prop], item),
      additionalLocationLabel: additionalLocationLabelKey
        ? additionalLocationLabelKey.reduce(
            (obj, prop) => obj && obj[prop],
            item
          )
        : null
    }))
    .reduce<Record<string, FormattedItem[]>>((acc, option) => {
      let formattedKey: string;

      switch (true) {
        case !!(parentKeyMap && option.parentKey !== OTHER_GROUP_KEY): {
          formattedKey =
            parentKeyMap.get(option.parentKey) || option.parentKey || '';
          break;
        }
        case isFormatParentKey:
          formattedKey = formatOptionParentKey(option.parentKey || '');
          break;
        default:
          formattedKey = option.parentKey || '';
      }

      if (!acc[formattedKey]) {
        acc[formattedKey] = [];
      }
      acc[formattedKey].push(option);
      return acc;
    }, {});

  return Object.keys(formattedItems).map((parentKey) => (
    <OptGroup key={parentKey} label={parentKey}>
      {formattedItems[parentKey].map((option: FormattedItem) => (
        <Option key={option.value} value={option.value}>
          {!additionalLocationLabelKey ? (
            option.label
          ) : (
            <div className="grouped-select-option">
              <div className="label">{option.label}</div>
              <div className="additional-label">
                {formatLocation(option.additionalLocationLabel)}
              </div>
            </div>
          )}
        </Option>
      ))}
    </OptGroup>
  ));
};
